import { type CarouselItemFieldsFragment, type InspirationItemFieldsFragment } from '../../../__generated__/graphql-client-types';
import { CARD_WIDTHS } from '../../../constants/home/general';
import { type CarouselItemContent, type InspirationCarouselItemContent } from '../../../types/construct.types';
import { type ExclusiveDealsItem, type SaleCategoriesItem } from '../../../types/home.types';

export type HomePageCarouselItem = SaleCategoriesItem | CarouselItemFieldsFragment | ExclusiveDealsItem | InspirationItemFieldsFragment;

export const findMaxCardWidth = (itemsCount: number): number => (itemsCount > 3 ? CARD_WIDTHS[2] : CARD_WIDTHS[itemsCount - 1]);

/**
 * Maps InspirationCarouselItemContent items to CarouselItemContent format.
 * This transformation adapts the inspiration carousel structure to the generic carousel component.
 */
export const mapInspirationItemsToCarouselContent = (items: InspirationCarouselItemContent[] | undefined): CarouselItemContent[] => {
	return (items ?? []).map((item: InspirationCarouselItemContent) => ({
		type: 'ObjectContent',
		fields: {
			title: item.fields.title,
			subtitle: item.fields.subTitle,
			link: {
				type: 'LinkContent',
				linkUrl: item.fields.link?.linkUrl ?? '',
				trackingCode: item.fields.link?.trackingCode ?? ''
			},
			image: {
				type: 'ImageContent',
				image: {
					id: item.fields.image?.image?.id ?? '',
					description: item.fields.image?.image?.description ?? '',
					imageType: item.fields.image?.image?.imageType ?? 'private',
					lowQualityPlaceholder: item.fields.image?.image?.lowQualityPlaceholder ?? null
				}
			},
			fontColor: undefined
		}
	}));
};
